module.exports = __webpack_public_path__ + "img/Treinamento_de_Teste_Rapido_para_HIV_e_outras_ISTs.c1b27d82.jpg";